/**
 * Google AdSense Utility
 * Handles AdSense script injection
 */

export const initializeAdSense = (): void => {
  if (typeof window === 'undefined') return;

  // Check if AdSense script is already loaded (from index.html)
  const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
  if (existingScript) {
    // Script is already in HTML head, no need to load again
    if (process.env.NODE_ENV === 'development') {
      console.log('ℹ️ AdSense script already loaded from HTML');
    }
    return;
  }

  // Fallback: Load dynamically if not in HTML (shouldn't happen in production)
  const pubId = process.env.REACT_APP_ADSENSE_PUB_ID;
  
  if (!pubId) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('⚠️ AdSense Publisher ID not found. Set REACT_APP_ADSENSE_PUB_ID in your .env file');
    }
    return;
  }

  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${pubId}`;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      if (process.env.NODE_ENV === 'development') {
        console.log('✅ AdSense script loaded successfully');
      }
    };
    script.onerror = () => {
      console.error('❌ Error loading AdSense script');
    };
    document.head.appendChild(script);
  } catch (error) {
    console.error('❌ Error initializing AdSense:', error);
  }
};
